import { AfterViewChecked, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { D3DonutChart, D3DonutChartData } from 'app/classes/d3-donut-chart';
import { Phase, PhaseType, PlanDocumentUtils as Utils, Template, UserLibrary } from 'fitforce-document-sync';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { LibraryItem } from '../../../../core/pipes/filter-user-library.pipe';

const emptyUUID = '00000000-0000-0000-0000-000000000000';
@Component({
  selector: 'document-plan-summary',
  templateUrl: './document-plan-summary.component.html',
  styleUrls: ['./document-plan-summary.component.scss'],
})
export class DocumentPlanSummaryComponent implements OnChanges, AfterViewChecked {
  donut: D3DonutChart;
  colors = {};
  colorsArray = [];
  stats: Map<string, D3DonutChartData>;
  legend: Phase[];
  showNone = false;
  noneColor = '#818181';

  searchText = '';
  libraryItems: LibraryItem[] = [];
  @Input() phases: Phase[];
  @Input() startDate: string;
  @Input() numWeeks: number;
  @Input() phaseTypes: PhaseType[];
  @Input() userLibrary: UserLibrary;

  @Output() templateItemRemoved: EventEmitter<Template> = new EventEmitter<Template>();

  guidedTourToggledOn = false;
  guidedTourStatusSub: Subscription;

  constructor() {}

  ngOnChanges() {
    this.concatUserLibrary();
    const startDate = moment(this.startDate);
    const endDate = startDate.clone().add(this.numWeeks, 'w');
    const totalDays = endDate.diff(startDate, 'd');

    this.stats = new Map<string, D3DonutChartData>();
    this.colors = {};
    this.colorsArray = [];

    let sum = 0;
    this.phases.forEach(phase => {
      const phaseStart = Utils.getDate(startDate, phase.start_day, phase.start_week);
      const phaseEnd = Utils.getDate(startDate, phase.end_day, phase.end_week).add(1, 'd');
      const phaseDays = phaseEnd.diff(phaseStart, 'd');
      let color: string;

      if (phase.color) {
        color = Utils.getHex(phase.color);
      } else {
        const foundPhaseType = this.phaseTypes.find(p => p.id === phase.exercise_program_phase_id);
        if (foundPhaseType) {
          color = Utils.getHex(foundPhaseType.color);
        }
      }

      this.colors[phase.exercise_program_phase_id || phase.id] = { name: phase.name, color: color };

      if (!this.stats[phase.exercise_program_phase_id || phase.id] || !this.stats[phase.exercise_program_phase_id || phase.id].count) {
        this.stats[phase.exercise_program_phase_id || phase.id] = { name: phase.name, color: color, count: phaseDays };
      } else {
        this.stats[phase.exercise_program_phase_id || phase.id].count += phaseDays;
      }
      sum += phaseDays;
    });

    if (sum !== totalDays) {
      this.stats[emptyUUID] = { name: 'No Phase', color: this.noneColor, count: totalDays - sum };
      this.showNone = true;
    } else {
      this.showNone = false;
    }
    this.colorsArray = Object.keys(this.colors);
  }

  ngAfterViewChecked() {
    if (!this.donut) {
      this.donut = new D3DonutChart({
        selector: '#pie',
        data: this.stats,
        height: 300,
        width: 300,
      });
      this.donut.update();
    } else {
      this.donut.update(this.stats);
    }
  }

  /**
   * Crates an array of user library workouts, items and rows.
   */
  concatUserLibrary(): void {
    this.libraryItems = [];
    if (this.userLibrary) {
      this.userLibrary.workouts.forEach((template) => {
        this.libraryItems.push({ type: 'Workout', item: template });
      });
      this.userLibrary.tiers.forEach((template) => {
        this.libraryItems.push({ type: 'Tier', item: template });
      });
    }
  }

  previewLibrary(item: LibraryItem) {
    console.warn('Clicked previewLibrary: ', item.item);
  }

  shareLibrary(item: LibraryItem) {
    console.warn('Clicked shareLibrary: ', item.item);
  }

  deleteLibrary(item: LibraryItem) {
    this.templateItemRemoved.emit(item.item);
  }
}
